import FieldPopover from "../../popover/popover"
import FieldConfig from "../../../proto/field-config"

import FieldSelectView_Popover from "./components/popover/popover"
import FieldSelectView_FormValueEmpty from "./components/form/value-empty"
import FieldSelectView_FormValueNotEmpty from "./components/form/value-not-empty"
import ProjectView from "../../../../model2/project-view/project-view"

export default class FieldSelectView extends FieldPopover {

    public views           : ProjectView[]

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel              = "Select view"

        this.views                 = _.get(config, 'views', [])

        this.noValueOption          = _.get(config, 'noValueOption', false)
        this.noValueOptionIcon      = _.get(config, 'noValueOptionIcon', undefined)
        this.noValueOptionLabel     = _.get(config, 'noValueOptionLabel', 'None')

        this.components = _.assign({}, this.components, {
            PopoverMenu             : FieldSelectView_Popover,

            FormValueEmpty          : FieldSelectView_FormValueEmpty,
            FormValueNotEmpty       : FieldSelectView_FormValueNotEmpty,
        })
    }

}